/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import appleFilled from '@iconify/icons-ant-design/apple-filled';
// material
import { alpha, styled } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';
import CountUp from 'react-countup';
import TokenDecoder from '../../../helpers/TokenDecoder';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';
import dashboardService from './DashboardService'


// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.info.darker,
  backgroundColor: theme.palette.info.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.info.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.info.dark, 0)} 0%, ${alpha(
    theme.palette.info.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

// const TOTAL = 1352831;



export default function AppNewUsers() {


  const OpID = parseInt(TokenDecoder.getGroupFactoryToken().factory);

  const [order, setOrder] = useState(0);

  async function GetOrderCount() {
    const response = await dashboardService.getOrderCount(OpID);
    if (response.length > 0) {
      setOrder(response[0].orderCount);
    }
  }

  useEffect(() => {
    GetOrderCount();
  }, [])


  return (
    <RootStyle>
      <IconWrapperStyle>
        {/* <Icon icon={appleFilled} width={24} height={24} /> */}
        < ReceiptLongIcon fontSize='large' width={50} height={60} />
      </IconWrapperStyle>
      <Typography variant="h3"><CountUp end={order} /></Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Today Order Count
      </Typography>
    </RootStyle>
  );
}
